/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class UrlDataService {
  productData = {};
  offerData = {};
  constructor() {}
}
